import {refreshAllControllers} from "@/scripts/common/api/scrolltrigger.services"

export const ReadMore = (() => {
    class RM {
        constructor(container, options) {
            this.$el = container
            this.options = Object.assign({}, {
                ...readMoreDefaultOptions,
                ...options,
                ...this.$el.dataset
            })
            this.expanded = this.options.expanded || false
            this.events={}
            this.init()
        }

        init() {
            this._createEvents()
            this._prepareString()
            this._addEventListeners()
            this._updateView()
        }

        _createEvents() {
            
            this.events['updated'] = new CustomEvent('updated', {
                bubbles: true,
                detail: {
                    isExpanded: () => this.expanded
                }
            })
        }

        _prepareString() {
            const text = this.$el.innerHTML
            this.$el.setAttribute("data-full-text", text)
        }

        _trimText() {
            return this.$el.dataset.fullText.substring(0, this.options.maxLength)
        }

        _readMore() {
            this.expanded = true
            this._updateView()
        }

        _readLess() {
            this.expanded = false
            this._updateView()
        }

        _updateView() {
            
            if(this.expanded) {
                this.$el.innerHTML = `${this.$el.dataset.fullText} ${ this.options.textLess ? `<a href="javascript:void(0)"  class="less-trigger link--primary-underlined"><span class="text-dark">${this.options.textLess}</span></a>` : '' }`
                this.$el.classList.add('expanded')
                this.$el.querySelector('.less-trigger').addEventListener('click', () => this._readLess())
                this.$el.dispatchEvent(this.events['updated'])
                return
            }

            this.$el.innerHTML = `${this._trimText()}...<a href="javascript:void(0)" class="more-trigger link--primary-underlined"><span class="text-dark">${this.options.textMore}</span></a>`
            this.$el.classList.remove('expanded')
            this.$el.querySelector('.more-trigger').addEventListener('click', () => this._readMore())
            this.$el.dispatchEvent(this.events['updated'])
        }

        // Event Callbacks
        _onUpdate(e) {
           // console.log(e.detail.isExpanded())
           refreshAllControllers() // ScrollController Refreshing
        }

        // EventsAdd
        _addEventListeners() {
            this.$el.addEventListener('updated', (e) => this._onUpdate(e))
        }
    }

    const readMoreDefaultOptions = {
        maxLength: 300,
        textMore: 'Read More',
        textLess: 'Read Less'
    }

    return {
        RM
    }
})()